import { getFirebase } from "@/firebase";
import { jwtDecode } from "jwt-decode";
import {
    signInWithEmailAndPassword,
    signInWithCustomToken,
} from "firebase/auth";

const TOKEN_KEY = "x-token";
const { auth } = getFirebase();

function getUser() {
    return auth.currentUser || null;
}
function getToken() {
    return localStorage.getItem(TOKEN_KEY);
}

export default {
    namespaced: true,
    state: {
        user: getUser(),
    },
    mutations: {
        SET_USER(state, data) {
            state.user = {
                email: data.email,
                displayName: data.displayName,
                photoURL: data.photoURL,
                lastSignInTime: data.metadata
                    ? data.metadata.lastSignInTime
                    : null,
            };
        },
        UPDATE_TOKEN(state, token) {
            localStorage.setItem(TOKEN_KEY, token);
        },
        USER_LOGOUT(state) {
            state.user = null;
            localStorage.removeItem(TOKEN_KEY);
        },
    },
    actions: {
        updateToken({ commit }, payload) {
            commit("SET_TOKEN", payload);
        },

        async loginFirebase({ commit }, payload) {
            const { email, password } = payload;
            // const credential = EmailAuthProvider.credential(email, password);

            try {
                const userCredential = await signInWithEmailAndPassword(
                    auth,
                    email,
                    password
                );

                const user = userCredential.user;

                const token = await user.getIdToken();

                commit("SET_USER", user);
                commit("UPDATE_TOKEN", token);
            } catch (error) {
                // Handle login errors
                // const errorCode = error.code;
                // const errorMessage = error.message;
                // console.error("Sign-in error:", errorMessage);
            }
        },

        getToken() {
            return getToken();
        },

        async loginFirebaseWithToken({ commit }, token) {
            try {
                if (!token) {
                    token = getToken();
                }

                if (!token) {
                    throw new Error("Token is required");
                }

                const decoded = jwtDecode(token);
                const userId = decoded.user_id;

                // console.log("decoded", decoded);
                // console.log("userId", userId);

                // const customToken = await createCustomToken(auth, userId);
                // console.log("decoded", decoded);

                // const userCredential = await signInWithCustomToken(
                //     auth,
                //     customToken
                // );
                // const user = userCredential.user;

                commit("SET_USER", {
                    email: decoded.email,
                    displayName: decoded.name,
                    photoURL: decoded.picture,
                });
            } catch (error) {
                // Handle login errors
                // const errorCode = error.code;
                // const errorMessage = error.message;
                // console.error("Sign-in error:", errorMessage);
            }
        },

        async logoutFirebase({ commit }) {
            try {
                auth.signOut();
                commit("USER_LOGOUT");
            } catch (error) {
                // console.error("Sign-out error:", error);
            }
        },

        async checkAuth({ commit }) {
            try {
                const user = await auth.currentUser;

                if (user) {
                    commit("SET_USER", user);
                    // console.log("checkAuth", true);
                    return true;
                } else {
                    throw new Error("User is not authenticated");
                }
            } catch (error) {
                // console.error("Error adding document: ", error);
                // console.log("checkAuth", false);
                return false;
            }
        },
    },

    getters: {
        user: (state) => state.user,
    },
};
